import React, { Component } from "react";
import { Row, Col, Table, Button, Nav, NavLink, NavItem, TabContent, TabPane, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import classnames from 'classnames';

// import { interval } from "rxjs";

// Components
import HeaderContainer from "../Header/HeaderContainer";
import OrganisationsList from "./OrganisationsList";
import SystemAnnouncement from "../SystemAnnouncements/SystemAnnouncementContainer";
import ClusterInformationList from "./ClusterInformationList";

// Strings
import { getMessage } from "CONFIG/i18n";
import { displayError } from "UTILS/Utility";

// Styles
import "./Organisations.less";

// Images
import KurentoServer from "ASSETS/Images/ic_Kurento_Monitoring_Server.svg";
import ServerOn from "ASSETS/Images/ic_server_on.svg";
import ServerOff from "ASSETS/Images/ic_server_off.svg";

// actions
import { organisationAction } from "CONFIG/ActionFactory";

import { convertMinutesToDDhhmm } from "UTILS/DateUtils";

// const API_CALL_INTERVAL = 9000;

class Organisations extends Component {
  constructor(props) {
    super(props);
    this.subscribe = null;
    this.state = {
      organizationsData: this.props.responseObject.data,
      // isSearchResult: false,
    };
  }

  componentDidMount() {
    // const source = interval(API_CALL_INTERVAL);
    // this.subscribe = source.subscribe(val => {
    //   this.getServerStatusAndUsersCount();
    // });
  }

  componentDidUpdate(prevProp) {
    if (
      !_.isEqual(
        this.props.responseObject.data,
        prevProp.responseObject.data
      ) &&
      !this.state.isSearchResult
    ) {
      this.setState({ organizationsData: this.props.responseObject.data });
    }
  }

  getServerStatusAndUsersCount = () => {
    organisationAction.userStatisticsAction().then(
      response_data => {
        let statstics = response_data.data.data;
        let serverCounts = this.state.summaryData;
        serverCounts.totalCustomers.value = statstics.totalCustomers;
        serverCounts.totalAgents.value = statstics.totalAgents;
        serverCounts.totalSessions.value = statstics.totalSessions;
        serverCounts.activeSessions.value = statstics.activeSessions;
        serverCounts.totalTimeToDate.value = convertMinutesToDDhhmm(statstics.totalTimeToDate);

        this.setState({
          summaryData: serverCounts,
          isKurentoServerOn: statstics.kmsStatus
        });
      },
      error => {
        if (error.status === 404) {
          displayError(getMessage("PAGE_NOT_FOUND"), "/", this);
        }
      }
    );
  };

  sortCustomerList = () => {
    this.props.sortCustomerList(this.props.responseObject, true);
  }

  setTabs = (event) => {
    organisationAction.saveCurrentActiveTab(event.target.id);
  }

  render() {
    return (
      <div>
        <HeaderContainer
          title={getMessage("ORGANIZATIONS")}
          headerButtonText={getMessage("ADD_ORGANIZATION")}
          history={this.props.history}
          handleSearchString={this.props.handleSearchString}
          onCancelButton={this.props.onCancelButton}
          isDashboard={true}
          gotoAddOrganization={this.props.gotoAddOrganization}
        />

        <Row className="summary">
          <Col lg={10} className="borderRight noPadding">
            <Row className="fitHeaderContent">
              {_.map(this.props.summaryData, (item, index) => {
                return (
                  <Col lg={2} key={index} className="summaryDiv">
                    <div key={index} className="summaryValue nameEllipsis" title={item.value} >
                      {item.value}
                    </div>
                    <div key={index + 1} className="summaryLabel">
                      {item.label}
                    </div>
                  </Col>
                );
              })}
            </Row>
          </Col>
          <Col lg={2} className="serverInfo px-lg-0 px-md-0">
            <div className="pt-4 pb-3 displayFlex justifyContentFlexCenter alignItemsCenter">
              {this.props.isKurentoServerOn ? (
                <img className="mr-2" src={ServerOn} />
              ) : (
                <img className="mr-2" src={ServerOff} />
              )}
              <img className="mr-2" src={KurentoServer} />
              <div>{getMessage("KMS")}</div>
            </div>
            {/* <div className="pt-2 pb-2 displayFlex alignItemsCenter">
              {this.props.serverStatus.isApplicationServerOn ? (
                <img className="mr-2" src={ServerOn} />
              ) : (
                <img className="mr-2" src={ServerOff} />
              )}
              <img className="mr-2" src={ApplicationServer} />
              <div>{getMessage("APPLICATION_SERVER")}</div>
            </div> */}
          </Col>
        </Row>

        <Row className="superAdminNavTabMargin">
          <Col className="noPadding">
            <Nav tabs className="superAdminNavTabBackground">
              <NavItem>
                <NavLink
                  id='1'
                  onClick={this.setTabs}
                  className={(this.props.currentActiveTab=='1') ? "otherActiveTabs organizationTab" : "otherTabs organizationTab"}
                >
                  {getMessage("ORGANIZATIONS")}
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  id='2'
                  onClick={this.setTabs}
                  className={(this.props.currentActiveTab==='2') ? "otherActiveTabs organizationTab" : "otherTabs organizationTab"}
                >
                  {getMessage("SYSTEM_ANNOUNCEMENTS")}
                </NavLink>
              </NavItem>

              {this.props.usingKmsCluster ?
                <NavItem>
                  <NavLink
                    id='3'
                    onClick={this.setTabs}
                    className={(this.props.currentActiveTab==='3') ? "otherActiveTabs organizationTab" : "otherTabs organizationTab"}
                  >
                    {getMessage("CLUSTER_INFO")}
                  </NavLink>
                </NavItem>
                : null}
            </Nav>
          </Col>
        </Row>

        {this.props.showTable && 
          <TabContent activeTab={this.props.currentActiveTab}>
            <TabPane tabId="1">
              <Row className="noMargin">
                <Col sm="12" className="noPadding">
                  <div>
                    {this.props.currentActiveTab === "1" ?
                      <OrganisationsList
                        organizationsData={this.props.responseObject.data}
                        gotoEditOrganization={this.props.gotoEditOrganization}
                        getAvailableModules={this.props.getAvailableModules}
                        showDeleteConfirmationModal={this.props.showDeleteConfirmationModal}
                        getAllUserData={this.props.getAllUserData}
                        handleSearchString={this.props.handleSearchString}
                        onCancelButton={this.props.cancelSearchString}
                        sortCustomerList={this.sortCustomerList}
                        language={this.props.language}
                      />: null
                    }
                  </div>
                </Col>
              </Row>
            </TabPane>

            <TabPane tabId="2">
              <div>
                {this.props.currentActiveTab === "2" ?
                  <div>
                    <SystemAnnouncement
                      language={this.props.language}
                    />
                  </div> 
                  : null}
              </div>
            </TabPane>

            <TabPane tabId="3">
              <div>
                {this.props.currentActiveTab === "3" ?
                  <div>
                    <ClusterInformationList
                      clusterData={this.props.clusterData}
                      turnClusterData={this.props.turnClusterData}
                      getClusterInfo={this.props.getClusterInfo}
                      getTurnClusterInfo={this.props.getTurnClusterInfo}
                      lastRefreshTime={this.props.lastRefreshTime}
                      lastRefreshTimeTurn={this.props.lastRefreshTimeTurn}
                      retireInstance={this.props.retireInstance}
                      usingTurnCluster={this.props.usingTurnCluster}
                      language={this.props.language}
                    /> 
                  </div>
                  : null}
              </div>
            </TabPane>
          </TabContent>
        }

        {/* {this.props.showTable && 
        <OrganisationsList
          organizationsData={this.props.responseObject.data}
          showEditOrganizationModal={this.props.showEditOrganizationModal}
          getAvailableModules={this.props.getAvailableModules}
          showDeleteConfirmationModal={this.props.showDeleteConfirmationModal}
          getAllUserData={this.props.getAllUserData}
          handleSearchString={this.props.handleSearchString}
          onCancelButton={this.props.cancelSearchString}
          sortCustomerList={this.sortCustomerList}
        />
        } */}
      </div>
    );
  }

  // componentWillUnmount() {
  //   this.subscribe ? this.subscribe.complete() : null;
  // }
}

export default Organisations;
